import { Component, Prop, Emit, Mixins } from "vue-property-decorator";
import SBComponentVue from '@/components/SBComponentVue';
import SBHorizontalScroll from './SBHorizontalScroll';

@Component({
    components: {},
})
export default class SBHorizontalScrollItem extends Mixins(SBComponentVue) {

    public created() {
        if (this.$parent) {
            let scroll: SBHorizontalScroll = <any>this.$parent;
            scroll.setChild(this);
        }
    }

    public fixed: boolean = true;
    public left: number = 0;
    public setLeft(left: number, fixed: boolean) {
        this.fixed = fixed;
        this.left = left;
    }

    public mounted() {
    }

}
